import { toast } from 'sonner'
import type { InAppNotification } from '../api/notifications-types'
import { resolveNotificationHref } from './resolve-notification-href'

export type LiveNotificationOpen = (notification: InAppNotification) => void

/** OS popup only when the person is not looking at this tab. */
export function shouldShowOsNotification(): boolean {
  if (typeof window === 'undefined' || !('Notification' in window)) return false
  if (Notification.permission !== 'granted') return false
  if (document.visibilityState === 'visible' && document.hasFocus()) return false
  return true
}

export function presentLiveNotification(
  notification: InAppNotification,
  open: LiveNotificationOpen,
): void {
  const href = resolveNotificationHref(notification.actionUrl)
  toast(notification.title, {
    description: notification.body,
    ...(href.kind === 'none'
      ? {}
      : {
          action: {
            label: 'Open',
            onClick: () => open(notification),
          },
        }),
  })

  if (!shouldShowOsNotification()) return

  try {
    const os = new Notification(notification.title, {
      body: notification.body,
      tag: notification.id,
    })
    os.onclick = () => {
      window.focus()
      os.close()
      open(notification)
    }
  } catch {
    // The browser refused the popup. The in-app toast already showed.
  }
}
